import React, { useContext } from 'react';
import { prettifyNumbers } from 'lib/dateUtilities';
import { NavigationUtils } from 'lib/navigationUtilities';
import { AuthContext } from 'components/user/AuthContext';
import { ReferrerContext } from 'components/layout/ReferrerContext';
import Button from 'components/element/Button';
import BackTitle from 'components/element/BackTitle';
import FollowButton from 'components/user/FollowButton';
import JoinedDate from 'components/layout/JoinedDate';
import FollowCount from 'components/layout/FollowCount';
import Banner from './Banner';

const PageHeader = ({ user }) => {
  const { navigateToLocation, locationPathName } = NavigationUtils();
  const { user: authenticatedUser } = useContext(AuthContext);
  const { getProfileBackDestination } = useContext(ReferrerContext);
  const isMe = authenticatedUser !== null && authenticatedUser.username === user.username;

  const handleBackClick = () => {
    const backDestination = getProfileBackDestination(locationPathName);
    navigateToLocation(backDestination);
  };

  return (
    <div className="border-t border-b border-gray-less">
      <BackTitle
        onClick={handleBackClick}
        hoverText="Back"
        title={user.name}
        subtitle={`${prettifyNumbers(user.twuts_count)} posts`}
      />
      <Banner avatar={user.avatar} banner={user.banner} username={user.username} />

      <div className="relative">
        <div className="absolute top-0 right-0 pt-3">
          {isMe ? (
            <Button
              onClick={() => navigateToLocation('/profile/edit')}
              className="whitespace-nowrap text-gray-strongest bg-gray-weak hover:bg-gray-less border border-gray-less hover:border-gray-mid"
            >
              Edit Profile
            </Button>
          ) : authenticatedUser ? (
            <FollowButton username={user.username} initialIsFollowing={user.is_following} />
          ) : (
            <></>
          )}
        </div>
        <div className="mt-0 p-4">
          <div className="mt-16">
            <h2 className="text-xl font-bold text-gray-strongest">{user.name}</h2>
            <p className="text-base text-gray-mid">@{user.username}</p>
            <p className="mt-2 text-base text-gray-strongest">{user.bio}</p>
            <JoinedDate date={user.joined_on} />
            <FollowCount following={user.following_count} followers={user.followers_count} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageHeader;
